import React from 'react';
import { Form } from 'formik';
import FormTextField from 'components/formComponents/FormTextField';
import WarningIcon from 'images/Icon_Warning_01.png';
import { Options } from './UpdateArchiveDate';

export const UpdateArchiveDateForm = () => {
  return (
    <Form>
      <h3 className="ArchiveNowPanelText">To organise your classes for next year you will need to archive.</h3>
      <p>
        Please note, by archiving now this will archive data across all subjects
        within your Get Set 4 Education curriculum.
      </p>
      <div className="Warning RedBack">
        <img src={WarningIcon} alt="Warning" />
        <p>This action cannot be undone</p>
      </div>
      <div className="LineSpacer5"></div>
      <div className="UpdateArchiveDatePassword">
        <FormTextField
          label="Enter your password"
          field="password"
          type="password"
          required={true}
          labelPosition="left"
        />
      </div>
    </Form>
  );
};
